import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserMailConfigService {

  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api/userMailConfig";

  createsMail(Mail: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, Mail)
  }

  getMailById(userMailConfigId: number): Observable<Object> {
    return this.http.get(`${this.url}/${userMailConfigId}`);
  }

  getAllMail(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
  getAllMailDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  getAllUserMailConfig(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown/user`);
  }

  MailSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {

    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  getApproved(supplier: any): Observable<Object> {
    return this.http.post(`${this.url}`, supplier);
  }
  addOrEditMail(forms: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, forms);
  }

  addOrEditSaveMail(forms: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/save`, forms);
  }

  public getmailConfig(): Observable<any> {

    return this.http.get(`${this.url}/userId`);

  }

  downloadUnitsReport(Page: number, size: number, sort, selectionUnits): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
    &size=${size}&sort=${sort}`, selectionUnits, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

  deleteById(userMailConfigId: any): Observable<Object> {
    return this.http.delete(`${this.url}/${userMailConfigId}`);
  }

  searchDynamicUserMailConfig(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/user${queryParams}`, requestBody);
  }

  accountVerified(account: any): Observable<Object> {
    return this.http.get(`${this.url}/account/${account}`);
  }

  emailAddressVerified(emailAddress: any, type: any = 1) {
    return this.http.get(`${this.url}/emailAddress/${emailAddress}?type=${type}`);
  }

}
